import { Achievement } from './types';

export const mockAchievements: Achievement[] = [
  {
    id: 'achievement-001',
    name: 'Math Explorer',
    description: 'Completed first math standard',
    icon: 'trophy',
    points: 100,
    achievementType: 'Standard',
    earnedAt: '2023-09-15T08:30:00Z'
  },
  {
    id: 'achievement-002',
    name: 'Number Master',
    description: 'Achieved 100% accuracy in number operations',
    icon: 'star',
    points: 150,
    achievementType: 'Standard',
    earnedAt: '2023-09-20T10:15:00Z'
  },
  {
    id: 'achievement-003',
    name: 'Game Champion',
    description: 'Won 5 math games in a row',
    icon: 'gamepad',
    points: 200,
    achievementType: 'Game',
    earnedAt: '2023-09-25T14:45:00Z'
  },
  {
    id: 'achievement-004',
    name: 'Persistent Problem Solver',
    description: 'Solved 10 hard problems without giving up',
    icon: 'puzzle',
    points: 250,
    achievementType: 'Milestone',
    earnedAt: '2023-10-01T09:20:00Z'
  },
  {
    id: 'achievement-005',
    name: 'Geometry Genius',
    description: 'Mastered all geometry standards for your grade',
    icon: 'shapes',
    points: 300,
    achievementType: 'Standard',
    earnedAt: '2023-10-10T11:30:00Z'
  },
  {
    id: 'achievement-006',
    name: 'Quick Calculator',
    description: 'Completed math quiz in record time',
    icon: 'clock',
    points: 175,
    achievementType: 'Game',
    earnedAt: '2023-10-15T13:10:00Z'
  },
  {
    id: 'achievement-007',
    name: 'Fraction Friend',
    description: 'Mastered fractions concepts',
    icon: 'pie-chart',
    points: 225,
    achievementType: 'Standard',
    earnedAt: '2023-10-20T15:00:00Z'
  },
  {
    id: 'achievement-008',
    name: 'Learning Streak',
    description: 'Logged in for 10 consecutive days',
    icon: 'fire',
    points: 150,
    achievementType: 'Milestone',
    earnedAt: '2023-10-25T08:45:00Z'
  },
  {
    id: 'achievement-009',
    name: 'Algebra Ace',
    description: 'Completed all algebra standards with high accuracy',
    icon: 'certificate',
    points: 350,
    achievementType: 'Standard',
    earnedAt: '2023-11-01T10:30:00Z'
  },
  {
    id: 'achievement-010',
    name: '100% Club',
    description: 'Achieved perfect score on 5 different assessments',
    icon: 'medal',
    points: 400,
    achievementType: 'Milestone',
    earnedAt: '2023-11-10T14:15:00Z'
  }
]; 